// import styled from 'styled-components';
import { styled, CSSObject, alpha } from '@mui/material/styles';

import { Breadcrumbs as MuiBreadcrumbs, Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';
import { StyledBreadcrumbsProps, LinkProps } from './types';

export const StyledBreadCrumbs = styled(MuiBreadcrumbs)<StyledBreadcrumbsProps>(({ theme }) => ({
  display: `inline-flex`,
  '.MuiBreadcrumbs-ol': {
    minHeight: `18px`,
    lineHeight: 1,
  },
  '.MuiBreadcrumbs-separator': {
    margin: `0 10px`,
    color: theme.palette.secondary[600],
  },
}));

export const StyledLink = styled(MuiLink, {
  shouldForwardProp: (prop) => !['$link', 'icon'].includes(String(prop)),
})<MuiLinkProps & LinkProps>(({ theme, $link }) => ({
  display: `inline-flex`,
  alignItems: `center`,
  maxWidth: `116px`,
  fontSize: `12px`,
  textDecoration: `none`,
  whiteSpace: `nowrap`,
  overflow: `hidden`,
  textOverflow: `ellipsis`,
  lineHeight: 1.5,
  ...($link
    ? {
        color: theme.palette.primary.main,
        cursor: `pointer`,
        '&:hover': {
          textDecoration: `underline`,
        },
      }
    : {
        color: theme.palette.secondary[600],
        cursor: `default`,
        '&:hover': {
          textDecoration: `none`,
        },
      }),
}));
//
// export const StyledLink = styled(MuiLink)<MuiLinkProps & LinkProps>(({ theme, link }) => ({
//   textDecoration: 'none',
//   display: 'inline-flex',
//   alignItems: 'center',
//   color: link ? theme.palette.primary.main : theme.palette.common.black,
//   '& span': {
//     fontSize: '14px',
//   },
//   ...(link && {
//     '&:hover': {
//       textDecoration: 'underline',
//     },
//     '&:active': {
//       color: theme.palette.common.black,
//     },
//     '&:focus': {
//       outlineWidth: '1px',
//       outlineStyle: 'solid',
//       outlineColor: theme.palette.common.black,
//     },
//   }),
// }));
